module.exports = "/images/arrow-right-s-line.svg?9661788d32deb5132d181dee0dacadda";